import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Paper,
  Grid,
  Typography,
  createStyles,
  makeStyles,
  Link
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { AppointmentConflict } from 'store/slices/appointments';
import { appointmentDomain } from 'models';

const useStyles = makeStyles(
  theme =>
    createStyles({
      iconWrapper: {
        display: 'flex',
        justifyContent: 'right',
        width: theme.spacing(6.875)
      },
      textWrapper: {
        padding: theme.spacing(1, 2, 1, 1)
      }
    }),
  { name: 'ConflictingEngineersBanner' }
);
interface ConflictingEngineersBannerProps {
  conflictedEngineers: number;
  totalEngineers: number;
  appointmentConflicts: AppointmentConflict[];
  className: string;
}

export default function ConflictingEngineersBanner({
  conflictedEngineers,
  totalEngineers,
  appointmentConflicts,
  className
}: ConflictingEngineersBannerProps) {
  const classes = useStyles();

  const unavailableEngineersViewUrl = useMemo(() => {
    if (appointmentConflicts.length === 0) return '';
    const params = new URLSearchParams({
      ids: appointmentConflicts.map(c => c.engineerId).join(','),
      reasons: appointmentConflicts.map(c => c.reason).join(',')
    });
    return `/dashboard/${appointmentDomain.urlPath}/unavailable-engineers?${params}`;
  }, [appointmentConflicts]);

  return (
    <Paper className={className}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item className={classes.iconWrapper}>
          <ErrorOutlineIcon color="error" />
        </Grid>
        <Grid item xs className={classes.textWrapper}>
          <Typography>
            {conflictedEngineers}/{totalEngineers} engineers already have a
            conflict at this time and may not be able to attend. Please fix this
            before proceeding.{' '}
            <Link
              component={RouterLink}
              to={unavailableEngineersViewUrl}
              target="_blank"
            >
              View all unavailable engineers
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
